import * as mooAPI from '~/libs/moo';

export function initGameLauncherEvent(bus) {
  /**
   * 启动器的逻辑处理, 暂时放这里, 等后续有更好的方式, 再做迁移
   * 启动器需要创建事件块来实现通信, 监听事件块的on函数处理, 只能全局挂载, 还没有一个纯逻辑按需加载的方式
   */
  bus.$on('rocket:gameLauncher:send', mooAPI.sendLauncherMessage);
  bus.$on('rocket:gameLauncher:initInfo', () =>
    mooAPI.sendLauncherMessage('InitInfo')
  );
  bus.$on('rocket:gameLauncher:changeGameDownloadPath', () =>
    mooAPI.sendLauncherMessage('ChangeGameDownloadPath')
  );
  bus.$on('rocket:gameLauncher:positionGameInstallPath', () =>
    mooAPI.sendLauncherMessage('PositionGameInstallPath')
  );
  bus.$on('rocket:gameLauncher:openGameInstallPath', () =>
    mooAPI.sendLauncherMessage('OpenGameInstallPath')
  );
  bus.$on('rocket:gameLauncher:gameUpdate', () =>
    mooAPI.sendLauncherMessage('GameUpdate')
  );
  bus.$on('rocket:gameLauncher:gameDown', () =>
    mooAPI.sendLauncherMessage('GameDown')
  );
  bus.$on('rocket:gameLauncher:gameDownPause', () =>
    mooAPI.sendLauncherMessage('GameDownPause')
  );
  bus.$on('rocket:gameLauncher:gameDownCancel', () =>
    mooAPI.sendLauncherMessage('GameDownCancel')
  );
  bus.$on('rocket:gameLauncher:uninstallGame', () =>
    mooAPI.sendLauncherMessage('UninstallGame')
  );
  bus.$on('rocket:gameLauncher:startGame', () =>
    mooAPI.sendLauncherMessage('StartGame')
  );
  bus.$on('rocket:gameLauncher:stopGame', () =>
    mooAPI.sendLauncherMessage('StopGame')
  );
  bus.$on('rocket:gameLauncher:checkGameExperienceVersion', () =>
    mooAPI.sendLauncherMessage('CheckGameExperienceVersion')
  );
  bus.$on('rocket:gameLauncher:gameExperienceUpdate', () =>
    mooAPI.sendLauncherMessage('GameExperienceUpdate')
  );
  bus.$on('rocket:gameLauncher:netReconnect', () =>
    mooAPI.sendLauncherMessage('NetReconnect')
  );
  bus.$on('rocket:gameLauncher:openWithBrowser', (URL) =>
    mooAPI.sendLauncherMessage('OpenWithBrowser', {
      url: URL,
    })
  );

  bus.$on('rocket:gameLauncher:setConfigAutoRun', (BOOL) =>
    mooAPI.sendLauncherMessage('SetConfigAutoRun', BOOL)
  );
  bus.$on('rocket:gameLauncher:setWhenQuitGamePop', (BOOL) =>
    mooAPI.sendLauncherMessage('SetWhenQuitGamePop', BOOL)
  );
  bus.$on('rocket:gameLauncher:setWhenClose', (VALUE) =>
    mooAPI.sendLauncherMessage('SetWhenClose', VALUE)
  );
  bus.$on('rocket:gameLauncher:setNetLimitOpen', (BOOL) =>
    mooAPI.sendLauncherMessage('SetNetLimitOpen', BOOL)
  );
  bus.$on('rocket:gameLauncher:setNetLimitRate', (VALUE) =>
    mooAPI.sendLauncherMessage('SetNetLimitRate', VALUE)
  );
  bus.$on(
    'rocket:gameLauncher:setConfig',
    (
      AutoRun,
      Shortcut,
      WhenClose,
      WhenQuitGamePop,
      NetLimitOpen,
      NetLimitRate,
      Channel
    ) =>
      mooAPI.sendLauncherMessage('SetConfig', {
        isAutoRun: AutoRun,
        isCreateShortcut: Shortcut,
        whenClose: WhenClose,
        whenQuitGamePop: WhenQuitGamePop,
        netLimit: {
          isOpen: NetLimitOpen,
          rate: NetLimitRate,
        },
        channel: Channel,
      })
  );

  bus.$on('rocket:gameLauncher:checkGameFile', () =>
    mooAPI.sendLauncherMessage('CheckGameFile')
  );
  bus.$on('rocket:gameLauncher:clearCache', () =>
    mooAPI.sendLauncherMessage('ClearCache')
  );
  bus.$on('rocket:gameLauncher:checkGameVersion', () =>
    mooAPI.sendLauncherMessage('CheckGameVersion')
  );
  bus.$on('rocket:gameLauncher:checkLauncherVersion', () =>
    mooAPI.sendLauncherMessage('CheckLauncherVersion')
  );
  bus.$on('rocket:gameLauncher:launcherUpdate', () =>
    mooAPI.sendLauncherMessage('LauncherUpdate')
  );
  bus.$on('rocket:gameLauncher:launcherDown', () =>
    mooAPI.sendLauncherMessage('LauncherDown')
  );

  bus.$on('rocket:gameLauncher:windowMini', () =>
    mooAPI.sendLauncherMessage('WindowMini')
  );
  bus.$on('rocket:gameLauncher:windowClose', () =>
    mooAPI.sendLauncherMessage('WindowClose')
  );
  bus.$on('rocket:gameLauncher:windowExit', () =>
    mooAPI.sendLauncherMessage('WindowExit')
  );
  bus.$on('rocket:gameLauncher:reGameDown', () =>
    mooAPI.sendLauncherMessage('ReGameDown')
  );
  bus.$on('rocket:gameLauncher:gameUninstall', () =>
    mooAPI.sendLauncherMessage('GameUninstall')
  );
  bus.$on('rocket:gameLauncher:statistic', (MESSAGE) =>
    mooAPI.sendLauncherMessage('Statistic', MESSAGE)
  );
  bus.$on('rocket:gameLauncher:postMessage', (MESSAGE, ORIGIN) => {
    const parentWindow = window.parent;
    if (!parentWindow) return;

    parentWindow.postMessage(MESSAGE, ORIGIN);
  });
}
